import { render } from "./OrderingIcon.vue?vue&type=template&id=39f1d8d6&scoped=true"
import script from "./OrderingIcon.vue?vue&type=script&lang=js"
export * from "./OrderingIcon.vue?vue&type=script&lang=js"

import "./OrderingIcon.vue?vue&type=style&index=0&id=39f1d8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f1d8d6"]])

export default __exports__